import React from "react";
import { Target, Award, Users, Globe } from "lucide-react";

const Values = () => {
  return (
    <div className="bg-white text-black py-10 sm:py-24 lg:py-20">
      <div className="max-w-6xl mx-auto px-6">
        
        {/* Header */}
        <div className="text-center mb-16 sm:mb-20">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-gray-500 mb-4">
            Foundation
          </p>

          <h2 className="text-2xl sm:text-3xl md:text-4xl font-thin mb-6">
            Our Core <em className="text-gray-400">Values</em>
          </h2>

          <p className="text-base sm:text-lg font-light leading-relaxed max-w-3xl mx-auto text-gray-600">
            The guiding principles behind our work, partnerships, and innovations
            as we advance responsible and accessible AI for all.
          </p>
        </div>

        {/* Values Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
          
          {/* Left Column */}
          <div className="space-y-12">
            
            {/* Innovation */}
            <div className="group p-8 border border-gray-200 rounded-xl hover:border-black transition-all duration-300">
              <div className="flex items-center mb-6">
                <Target className="w-6 h-6 mr-4 text-gray-400 group-hover:text-black transition-colors" />
                <h3 className="text-lg sm:text-xl font-light tracking-wide">
                  Innovation
                </h3>
              </div>
              <p className="text-gray-600 font-light leading-relaxed">
                Advancing new ideas and technologies that empower professionals
                and enterprises, continually expanding what is achievable with AI.
              </p>
            </div>

            {/* Integrity */}
            <div className="group p-8 border border-gray-200 rounded-xl hover:border-black transition-all duration-300">
              <div className="flex items-center mb-6">
                <Award className="w-6 h-6 mr-4 text-gray-400 group-hover:text-black transition-colors" />
                <h3 className="text-lg sm:text-xl font-light tracking-wide">
                  Integrity
                </h3>
              </div>
              <p className="text-gray-600 font-light leading-relaxed">
                Building trust through transparent communication, ethical
                practices, and responsible AI implementation that prioritizes
                people and long-term impact.
              </p>
            </div>

          </div>

          {/* Right Column */}
          <div className="space-y-12">
            
            {/* Empowerment */}
            <div className="group p-8 border border-gray-200 rounded-xl hover:border-black transition-all duration-300">
              <div className="flex items-center mb-6">
                <Users className="w-6 h-6 mr-4 text-gray-400 group-hover:text-black transition-colors" />
                <h3 className="text-lg sm:text-xl font-light tracking-wide">
                  Empowerment
                </h3>
              </div>
              <p className="text-gray-600 font-light leading-relaxed">
                Enabling individuals and organizations to unlock their full
                potential with AI, ensuring inclusive access to transformative
                skills and tools.
              </p>
            </div>

            {/* Collaboration */}
            <div className="group p-8 border border-gray-200 rounded-xl hover:border-black transition-all duration-300">
              <div className="flex items-center mb-6">
                <Globe className="w-6 h-6 mr-4 text-gray-400 group-hover:text-black transition-colors" />
                <h3 className="text-lg sm:text-xl font-light tracking-wide">
                  Collaboration
                </h3>
              </div>
              <p className="text-gray-600 font-light leading-relaxed">
                Building strong, cross-sector partnerships that fuel shared
                progress, recognizing that meaningful innovation happens
                together, not alone.
              </p>
            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default Values;
